"use client";
import { useState } from "react";
import { useController, useFormContext } from "react-hook-form";
import { NativeSyntheticEvent, StyleSheet } from "react-native";

import { createRhfRef } from "../../../utils";
import { useFocus } from "../../hooks";
import { FieldProps } from "../types";
import InputDropdown, { InputDropdownProps } from "./InputDropdown";

export type InputDropdownRHFProps = FieldProps<string> &
  Omit<InputDropdownProps<any>, "value"> & {
    leftHelper?: string;
    rightHelper?: string;
  };

export default function InputDropdownRHF(props: InputDropdownRHFProps) {
  const {
    defaultValue,
    name,
    validate,
    onFocus,
    label,
    leftHelper,
    rightHelper,
    disabled,
    style,
    onPressItem,
    items,
    searchable,
    ...inputDropdownProps
  } = props;
  const [searchedValue, setSearchedValue] = useState("");

  const { control } = useFormContext();
  const {
    field: { value, onBlur, onChange, ref },
    fieldState: { error },
  } = useController({
    control,
    name,
    rules: {
      validate,
    },
    defaultValue,
  });
  function handleBlur() {
    onBlur();
    setSearchedValue("");
  }
  function handleFocus(e: NativeSyntheticEvent<any>) {
    if (typeof onFocus === "function") {
      onFocus(e);
    }
  }

  const [focused, focusHandler] = useFocus({
    onFocus: handleFocus,
    onBlur: handleBlur,
  });

  function handleChangeText(text: string) {
    setSearchedValue(text);
  }

  function handlePressItem(item: any) {
    onChange(item.value);
    onPressItem && onPressItem(item);
  }

  let valueToDisplay = value;
  if (focused && searchable) {
    valueToDisplay = searchedValue;
  }

  return (
    <InputDropdown
      {...inputDropdownProps}
      {...focusHandler}
      searchable={searchable}
      errorRef={createRhfRef(ref)}
      style={style}
      label={label}
      error={error?.message}
      startHelper={leftHelper}
      endHelper={rightHelper}
      disabled={disabled}
      items={items}
      onPressItem={handlePressItem}
      onChangeText={handleChangeText}
      value={valueToDisplay || ""}
      containerStyle={styles.input}
      labelAsInputValue
    />
  );
}

const styles = StyleSheet.create({
  input: {
    zIndex: 1,
  },
});
